import { useQuery } from "@tanstack/react-query";

import { getCartonPropertyGroupConfigurationHistory } from "@/api/audit-configuration-history-api";
import { type AuditRecord } from "@/components/diff-view";

export const CARTON_PROPERTY_GROUP_CONFIGURATION_HISTORY_QUERY_KEY = "carton-property-group-configuration-history";

export const useCartonPropertyGroupConfigurationHistory = (id: string, enabled: boolean) => {
	return useQuery<AuditRecord[]>({
		queryKey: [CARTON_PROPERTY_GROUP_CONFIGURATION_HISTORY_QUERY_KEY, id],
		queryFn: () => getCartonPropertyGroupConfigurationHistory(id),
		initialData: [],
		retry: false,
		enabled,
	});
};
